import './Loader.scss';

export const Loader = () => (
  <div className="simple-spinner">
    <span></span>
  </div>
);